.je{gap:0.125rem;}